// Hooks
import React, { useEffect, useState } from 'react';

// Componentes
import { Container, Row, Card, CardHeader, CardBody } from 'reactstrap';
import SimpleHeader from 'components/Headers/SimpleHeader.js';

// Serviços
import LostReasonService from '../services/LostReasonService';

import { TableLostReasonFields } from '../table';
const LostReasonList = () => {
  const [lostReasonList, setLostReasonList] = useState([]);

  const getLostReasonList = async () => {
    await LostReasonService.getAll().then((response) => {
      setLostReasonList(response.data.data.data);
    });
  };

  useEffect(() => {
    getLostReasonList();
  }, []);

  return (
    <>
      <SimpleHeader
        setCreate="/admin/crm/lostReason/form"
        name="Form validation"
        parentName="Forms"
      />
      <Container className="mt--6" fluid>
        <Row>
          <div className="col">
            <div className="card-wrapper">
              <Card>
                <CardHeader>
                  <h3 className="mb-0">Motivos de Perda</h3>
                </CardHeader>
                <CardBody>
                  <TableLostReasonFields
                    fields={lostReasonList}
                  ></TableLostReasonFields>
                </CardBody>
              </Card>
            </div>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default LostReasonList;
